import ic_cancel from '@/assets/images/icons/cancel.svg';
import ic_check_circle from '@/assets/images/icons/checkbox-circle.svg';
import ic_error from '@/assets/images/icons/error.svg';
import { FlashContext } from '@/providers/flashProvider';
import { bem } from '@/utilities';
import React, { useContext } from 'react';

export const Flash: React.FC = () => {
  const { flash, setFlash } = useContext(FlashContext);

  if (flash) {
    return (
      <div className='flash'>
        <div className={bem('flash', 'body', { success: flash.type === 'success', error: flash.type === 'error' })}>
          <div className={bem('flash', 'container')}>
            <img className={bem('flash', 'icon')} src={flash.type === 'success' ? ic_check_circle : ic_error} />
            <p className={bem('flash', 'message')}>{flash.message}</p>
            <button className={bem('flash', 'delete-button')} onClick={() => setFlash(null)}>
              <img className={bem('flash', 'cross')} src={ic_cancel} />
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
